'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _objectSpread = require('@babel/runtime/helpers/objectSpread2');
var theme_common_primitives_commonPrimitives = require('./commonPrimitives.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _objectSpread__default = /*#__PURE__*/_interopDefaultLegacy(_objectSpread);

/*
      ---------- COLORS ----------
*/
var defaultShadowPrimitives = {
  4: '0 1px 4px hsla(0, 0%, 0%, 0.16)',
  8: '0 2px 8px hsla(0, 0%, 0%, 0.16)'
};
/*
      ---------- SPACING ----------
*/
var defaultSizePrimitives = {
  0: '0',
  2: '2px',
  4: '4px',
  6: '6px',
  8: '8px',
  10: '10px',
  12: '12px',
  14: '14px',
  16: '16px',
  18: '18px',
  20: '20px',
  22: '22px',
  24: '24px',
  26: '26px',
  28: '28px',
  30: '30px',
  32: '32px',
  36: '36px',
  38: '38px',
  40: '40px',
  48: '48px',
  56: '56px',
  64: '64px',
  72: '72px',
  80: '80px',
  96: '96px',
  128: '128px',
  192: '192px'
};
/*
      ---------- BORDER WIDTHS ----------
*/
var defaultBorderWidthPrimitives = {
  0: '0',
  1: '1px',
  2: '2px',
  3: '3px',
  4: '4px',
  5: '5px',
  6: '6px',
  8: '8px',
  10: '10px'
};
/*
      ---------- BREAK POINTS ----------
*/
var defaultBreakpointPrimitives = {
  xs: '360px',
  sm: '576px',
  md: '768px',
  lg: '992px',
  xl: '1280px'
};
/*
      ---------- TRANSITIONS ----------
*/
var defaultTransitionTimingFn = 'cubic-bezier(0,.75,.6,.75)';
/*
      ---------- FONTS ----------
*/
var defaultFontSizePrimitives = {
  11: '11px',
  12: '12px',
  14: '14px',
  16: '16px',
  18: '18px',
  20: '20px',
  22: '22px',
  24: '24px',
  26: '26px',
  28: '28px',
  30: '30px',
  32: '32px',
  34: '34px',
  36: '36px',
  38: '38px',
  40: '40px'
};
var defaultFontWeightPrimitives = {
  100: 100,
  200: 200,
  300: 300,
  400: 400,
  500: 500,
  600: 600,
  700: 700,
  800: 800,
  regular: 400,
  medium: 500,
  bold: 700
};
var defaultLineHeightPrimitives = {
  1: '1',
  12: '12px',
  14: '14px',
  16: '16px',
  18: '18px',
  20: '20px',
  22: '22px',
  24: '24px',
  26: '26px',
  34: '34px',
  42: '42px'
};
var defaultLetterSpacingPrimitives = {
  0: '0',
  '0.5': '0.5px',
  '0.8': '0.8px',
  '1': '1px'
};
var defaultPrimitives = _objectSpread__default["default"]({
  sizes: defaultSizePrimitives,
  breakpoints: defaultBreakpointPrimitives,
  borderWidths: defaultBorderWidthPrimitives,
  fontSizes: defaultFontSizePrimitives,
  fontWeights: defaultFontWeightPrimitives,
  lineHeights: defaultLineHeightPrimitives,
  letterSpacings: defaultLetterSpacingPrimitives,
  shadows: defaultShadowPrimitives,
  transitionTimingFn: defaultTransitionTimingFn
}, theme_common_primitives_commonPrimitives.commonPrimitives);

exports.defaultBorderWidthPrimitives = defaultBorderWidthPrimitives;
exports.defaultBreakpointPrimitives = defaultBreakpointPrimitives;
exports.defaultFontSizePrimitives = defaultFontSizePrimitives;
exports.defaultFontWeightPrimitives = defaultFontWeightPrimitives;
exports.defaultLetterSpacingPrimitives = defaultLetterSpacingPrimitives;
exports.defaultLineHeightPrimitives = defaultLineHeightPrimitives;
exports.defaultPrimitives = defaultPrimitives;
exports.defaultShadowPrimitives = defaultShadowPrimitives;
exports.defaultSizePrimitives = defaultSizePrimitives;
exports.defaultTransitionTimingFn = defaultTransitionTimingFn;
//# sourceMappingURL=defaultPrimitives.js.map
